module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "mail.8c605da2.svg";